import React from 'react';
import { FullPetDetailsPropTypes } from '../../../propTypes/petDetails';
import { maskBankInfo } from '../../../utils/maskDetails';
import { PAYMENT_METHOD } from '../../../constants/constants';

export const ReimbursementDetailsPanel = ({ selectedPet }) => {
  const {
    PolicyDetails: {
      ReimbursementInfo: { paymentMethod, bsbNumber, accountNumber, accountHolderName }
    }
  } = selectedPet;

  const showDirectDebitHolder = paymentMethod === 'Direct Debit' && accountNumber && accountHolderName;

  return (
    <section>
      <span className="labelValueText">
        <em>Method</em>
        <strong>
          {(accountNumber && accountHolderName) || paymentMethod.toUpperCase() === PAYMENT_METHOD.CHEQUE
            ? paymentMethod
            : 'Please add your reimbursement details so we can pay your claims.'}
        </strong>
      </span>

      {showDirectDebitHolder && (
        <>
          <span className="labelValueText">
            <em>Account name</em>
            <strong>{accountHolderName}</strong>
          </span>

          <span className="labelValueText">
            <em>BSB</em>
            <strong>{maskBankInfo(bsbNumber)}</strong>
          </span>

          <span className="labelValueText">
            <em>Account No.</em>
            <strong>{maskBankInfo(accountNumber)}</strong>
          </span>
        </>
      )}
    </section>
  );
};

ReimbursementDetailsPanel.propTypes = {
  selectedPet: FullPetDetailsPropTypes
};
